var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:`badge  badge-pill mb-0 ` + _vm.lastUpdatedBadge},[_vm._v("Cal last updated: "+_vm._s(_vm.lastUpdated)+".")]),_c('p',{class:`badge badge-pill mb-0 ` + _vm.externalCalendarSyncBadge},[_vm._v("External Calendar Sync "+_vm._s(_vm.externalCalendarSyncStatus))])])
}
var staticRenderFns = []

export { render, staticRenderFns }